<template>
    <!-- Conteneur pour les liens directs d'accès rapide -->
    <div class="direct-links">
        <!-- Génération dynamique des boutons de navigation à partir de la configuration injectée -->
        <!-- Chaque bouton ouvre une nouvelle page selon l'URL configurée -->
        <a v-for="(button, index) in buttons" :key="index" :href="button.href" :id="button.id"
            class="btn btn-sm btn--plain btn--primary">
            {{ button.label }}
        </a>
    </div>
</template>

<script>
export default {
    name: 'DirectLinks',

    // Injection de dépendance : récupère la configuration des boutons depuis le composant parent
    // Utilise le système provide/inject de Vue pour un couplage faible
    inject: {
        buttons: {
            // Nom de la clé fournie par le composant parent via provide()
            from: 'directLinks',
            // Configuration par défaut si aucune injection n'est disponible
            // Contient les liens standards : API, SPARQL et FHIR
            default: () => [
                { label: 'API', href: '/api-docs', id: 'direct-link-api' },
                { label: 'SPARQL', href: '/sparql', id: 'direct-link-sparql' },
                { label: 'FHIR', href: '/fhir', id: 'direct-link-fhir' }
            ]
        }
    }
}
</script>

<style scoped>
/* Styles pour le composant DirectLinks */

/* Conteneur principal : disposition en ligne avec espacement entre les éléments */
.direct-links {
    display: flex;
    gap: 1rem;
    /* Espacement de 1rem entre chaque bouton de lien */
}
</style>